import React, { FC } from "react";
import { Spin, Typography } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Logo } from "../header/logo";
import styles from "./page-loading.css";

const {
  container,
  footer,
  error: errorClassName,
  title,
  logoWrapper,
  spinner,
  loadingContent,
} = styles as any;

export type LoginContentProps = {
  loading: boolean;
  error?: Error;
};

const customSpinIcon = <LoadingOutlined style={{ fontSize: 48, color: "var(--white)" }} spin />;

export const PageLoading: FC<LoginContentProps> = ({ loading, error, children }) => {
  return (
    <div className={container}>
      <div className={logoWrapper}>
        <Logo />
      </div>
      <Typography.Title className={title}>
        <span>Legal Pricing Made Simple</span>
      </Typography.Title>
      <div className={footer}>
        {loading ? (
          <div className={loadingContent}>
            <Spin className={spinner} indicator={customSpinIcon} size="large" />
            <Typography.Text
              style={{
                marginTop: "var(--margin-md)",
                color: "var(--white)",
                fontSize: "var(--font-size-lg)",
              }}
            >
              Loading your workspace...
            </Typography.Text>
          </div>
        ) : (
          children
        )}
        {error && (
          <Typography.Paragraph type="danger" className={errorClassName}>
            {error.message || " "}
          </Typography.Paragraph>
        )}
      </div>
    </div>
  );
};
